import React, { FC, useContext, useMemo } from 'react';

import { UIFeatures } from '../types';

import UIFeaturesContext from './context';

export interface UIFeaturesProviderProps {
  readonly features: UIFeatures;
}

const UIFeaturesProvider: FC<UIFeaturesProviderProps> = ({ features: overridenFeatures, ...props }) => {
  const inheritedFeatures = useContext(UIFeaturesContext);
  const features = useMemo(
    () => ({ ...inheritedFeatures, ...overridenFeatures }),
    [inheritedFeatures, overridenFeatures]
  );

  return <UIFeaturesContext.Provider {...props} value={features} />;
};

export default UIFeaturesProvider;
